<template>
    <div class="exam-management">
        <div id="List_Tittle">
            <p>{{ $t("exam.label.list_exam") }}</p>
        </div>
        <b-modal id="modal-auto" hide-footer hide-header size="xl">
            <ModalAuto @close-modal-auto="onClose" :imageFileExam="imageFileExam" :image_s3="image_s3"
                       :imageFileExamUpload="imageFileExamUpload" :name="nameEdit" :method="methodEdit"
                       :category="categoryEdit" :listDifficulties="listDifficulties" :typeApi="typeApi"
                       :idApi="idApi"
                       @load-exam="fillterExam">
            </ModalAuto>
        </b-modal>
        <b-modal id="modal-info-exam" hide-footer size="xl">
            <ModalInfoExam :idExam="idApi" @close-modal-info="onClose">
            </ModalInfoExam>
        </b-modal>
        <div
            id="pop-up"
            v-if="createExam === true || deleteExam === true
                || infoExam === true ||advancedExam === true "
            @click="onClose()"
        ></div>

        <!-- CREATE DIFFICULTY -->
        <div v-if="createExam === true" class="create_Diff">
            <div class="create_Diff_Header mt-4">
                <h5>{{ $t("exam.label.name_exam") }}</h5>
            </div>

            <template>
                <div>
                    <b-input class="title-exam-name" type="text" name="examName"
                             :placeholder="$t(`exam.label.enter_exam_name`)"
                             v-model="examName" maxlength="255"
                    />
                </div>
            </template>
            <div class="create_Diff_Mid">

                <div class="create_Diff_UploadImage">
                    <div v-if="imageFileExam" style="position: relative">
                        <img class="image-exam mt-4 mb-4" :src="imageFileExam"/>
                        <button @click="removeImage" class="icon-remove-img">X</button>
                    </div>
                    <div v-if="!imageFileExam" class="setTime_Upload_Icon">
                        <ion-icon name="cloud-upload-outline"></ion-icon>
                    </div>
                    <div class="setTime_Upload_Input my-4" v-if="!imageFileExam">
                        <b-form-file
                            accept=".jpeg, .png, .jpg"
                            drop-placeholder="Upload Image"
                            @change="imageExam"
                            :placeholder="$t(`exam.label.update_image`)"
                            :file-name-formatter="formatfilename"
                        >
                        </b-form-file>
                    </div>
                </div>

                <div class="create_Diff_Attribute">
                    <div class="create_Diff_Method align-items-center">
                        <p>{{ $t("exam.label.method") }} <span style="color: red">*</span> :</p>
                        <div class="create_Diff_Method_Option">
                            <b-form-select
                                v-model="selectedMethod"
                            >
                                <b-form-select-option value="manual">{{ $t("exam.label.manual") }}</b-form-select-option>
                                <b-form-select-option value="auto">{{ $t("exam.label.auto") }}</b-form-select-option>
                            </b-form-select>
                        </div>
                    </div>
                    <div class="create_Diff_Category align-items-center">
                        <p>{{ $t("exam.label.category") }} <span style="color: red">*</span> :</p>
                        <div class="create_Diff_Method_Option">
                            <multiselect
                                v-model="categorySelected"
                                selectLabel="√"
                                track-by="id"
                                label="category"
                                :options="listCategory"
                                :hide-selected="true"
                                :close-on-select="true"
                                :clear-on-select="false"
                                placeholder=""
                                @input="checkCategoryPermission($event, 'create')"
                                
                            >
                            </multiselect>
                        </div>
                    </div>
                </div>
            </div>
            <div class="create_Diff_Bottom">
                <div class="create_Diff_Bottom_Button">
                    <b-button @click="onClose()" variant="danger"
                    >{{ $t("exam.label.cancel") }}
                    </b-button
                    >
                    <b-button
                        :disabled="examName.length === 0 || !categorySelected || selectedMethod.length === 0 || imageFileExam === ``"
                        @click="categoryEdit = categorySelected; showModal(selectedMethod);
                                    nameEdit = examName;  tableRight = listQuestions.data;
                                    methodEdit = selectedMethod
                                    questionSelected = [];"
                        style="margin-left: 1rem; background-color: #0069d9; border: none; width: 130px"
                        variant="primary"
                        class="btn-Next"
                    >{{ $t("exam.label.next") }}
                    </b-button>
                </div>
            </div>
        </div>

        <!--        EDIT EXAM-->
        <div v-if="infoExam === true" class="create_Diff">
            <div class="create_Diff_Header mt-4">
                <h5>{{ $t("exam.label.name_exam") }}</h5>
            </div>

            <template>
                <div>
                    <input class="title-exam-name form-control" type="text" name="examName"
                           :placeholder="$t(`exam.label.enter_exam_name`)"
                           v-model="nameEdit" maxlength="255">
                </div>
            </template>
            <div class="create_Diff_Mid">

                <div class="create_Diff_UploadImage">
                    <div v-if="imageFileExam" style="position: relative">
                        <img class="image-exam mt-4 mb-4" :src="imageFileExam"/>
                        <button @click="removeImage" class="icon-remove-img mt-2">X</button>
                    </div>
                    <div v-if="!imageFileExam" class="setTime_Upload_Icon">
                        <img class="image-exam mt-4" :src="image_s3" v-if="image_s3"/>
                        <img class="image-exam mt-4" src="../Rectangle.png" v-else/>
                    </div>
                    <div class="setTime_Upload_Input my-4" v-if="!imageFileExam">
                        <b-form-file
                            accept=".jpeg, .png, .jpg"
                            drop-placeholder="Upload Image"
                            @change="imageExam"
                            :placeholder="$t(`exam.label.update_image`)"
                            :file-name-formatter="formatfilename"
                        >
                        </b-form-file>
                    </div>
                </div>

                <div class="create_Diff_Attribute">
                    <div class="create_Diff_Method">
                        <p>{{ $t("exam.label.method") }} <span style="color: red">*</span> :</p>
                        <div class="create_Diff_Method_Option">
                            <b-form-select
                                v-model="methodEdit"
                            >
                                <b-form-select-option value="manual">{{ $t("exam.label.manual") }}</b-form-select-option>
                            </b-form-select>
                        </div>
                    </div>
                    <div class="create_Diff_Category">
                        <p>{{ $t("exam.label.category") }} <span style="color: red">*</span> :</p>
                        <div class="create_Diff_Method_Option">
                            <multiselect
                                v-model="categoryEdit"
                                selectLabel="√"
                                track-by="id"
                                label="category"
                                :options="listCategory"
                                :hide-selected="true"
                                placeholder=""
                                @input="checkCategoryPermission($event, 'edit')"
                            >
                            </multiselect>
                        </div>
                    </div>
                </div>
            </div>
            <div class="create_Diff_Bottom">
                <div class="create_Diff_Bottom_Button">
                    <b-button @click="onClose()" variant="danger"
                    >{{ $t("exam.label.cancel") }}
                    </b-button
                    >
                    <b-button
                        @click=" createExam = false;saveExam();"
                        style="margin-left: 1rem; width: 120px"
                        variant="primary"
                        :disabled="nameEdit.length === 0 || methodEdit.length === 0 || !categoryEdit || (image_s3 ? false : imageFileExam === ``)"
                        class="btn-Next"
                    >{{ $t("exam.label.save") }}
                    </b-button>
                    <b-button
                        @click="showModal(methodEdit)"
                        style="margin-left: 1rem; background-color: #FFBF00; width: 130px"
                        variant="primary"
                        :disabled="nameEdit.length === 0 || methodEdit.length === 0 || !categoryEdit || (image_s3 ? false : imageFileExam === ``)"
                        class="btn-Next"
                    >{{ $t("exam.label.next") }}
                    </b-button
                    >
                </div>
            </div>
        </div>

        <!-- DELETE DIFFICULTY -->
        <div v-if="deleteExam === true" class="delete_Diff">
            <div @click="deleteExam = false" class="delete_Diff_Close">
                <ion-icon name="close-outline"></ion-icon>
            </div>
            <div class="delete_Diff_Header">
                <h5>{{$t("setting.label.confirm_delete_title")}}</h5>
            </div>
            <div class="delete_Diff_Des">
                <section>{{$t("exam.message.confirm_delete_exam")}}</section>
            </div>
            <div class="delete_Diff_Bottom">
                <div class="delete_Diff_Bottom_Button">
                    <b-button @click="onClose()" variant="danger"
                    >{{ $t("exam.label.cancel") }}
                    </b-button
                    >
                    <b-button
                        @click="deleteExam = false; saveExam()"
                        style="margin-left: 1rem"
                        variant="primary"
                    >{{ $t("exam.label.confirm") }}
                    </b-button
                    >
                </div>
            </div>
        </div>

        <!-- TODO QUESTION -->

        <div v-if="advancedExam === true" class="create_Advanced_Diff">
            <div class="create_Advanced_Diff_Top" style="height: 200px">
                <div class="create_Advanced_Diff_Top_Left">
                    <div class="create_Advanced_Diff_Top_Left_Top">
                        <p>{{ nameEdit }}</p>
                    </div>

                    <div class="create_Advanced_Diff_Top_Left_Mid">
                        <div class="create_Advanced_Diff_Top_Left_Mid_Left ">
                            <div class="create_Advanced_Diff_Top_Left_Mid_Left1" style="width: 100%">
                                <div class="has-search-right" style="height: 30px">
                                    <b-input-group>
                                        <b-input-group-prepend is-text>
                                            <b-icon style="height: 12px" icon="search"></b-icon>
                                        </b-input-group-prepend>
                                        <b-form-input
                                            :placeholder="$t('question_list.label.placeholder_search')"
                                            v-model="fillterQuestion.search"
                                            @change="getQuestion"
                                            style="border-radius: 0 8px 8px 0 !important; border-left: none"
                                            maxlength="256"
                                        ></b-form-input>
                                    </b-input-group>

                                </div>
                            </div>
                            <div class="type-select d-flex justify-content-between align-items-center my-2">
                                <p>{{$t("exam.label.type")}}:</p>
                                <div class="">
                                    <b-form-select
                                        v-model="fillterQuestion.selected.typeQuestion"
                                        :options="typeQuestionOption"
                                        @input="getQuestion"
                                    >
                                        <template v-slot:first>
                                            <b-form-select-option :value="null">
                                                {{$t("exam.label.all")}}
                                            </b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </div>
                            </div>
                            <div class="type-of-question-select d-flex justify-content-between align-items-center ">
                                <p>{{$t("exam.label.type_of_question")}}:</p>
                                <div class="">
                                    <b-form-select
                                        v-model="fillterQuestion.selected.typeOfQuestion"
                                        @input="getQuestion">
                                        <b-form-select-option value="General">{{$t("exam.label.general")}}</b-form-select-option>
                                        <b-form-select-option value="Group">{{$t("exam.label.group_question")}}</b-form-select-option>
                                    </b-form-select>
                                </div>
                            </div>
                        </div>
                        <div class="create_Advanced_Diff_Top_Left_Mid_Right">
                            <div class="category-select d-flex justify-content-between align-items-center">
                                <p>{{$t("exam.label.category")}}:</p>
                                <div class="ml-1">
                                    <b-form-select
                                        id="category"
                                        v-model="fillterQuestion.selected.category"
                                        :options="categoryQuestion"
                                        @input="getQuestion"
                                    >
                                        <template v-slot:first>
                                            <b-form-select-option :value="null">
                                                {{$t("exam.label.all")}}
                                            </b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </div>
                            </div>
                            <div class="difficulty-select d-flex justify-content-between align-items-center my-2">
                                <p>{{$t("exam.label.difficulty")}}:</p>
                                <div class="">
                                    <b-form-select
                                        v-model="fillterQuestion.selected.difficulty"
                                        :options="difficultyQuestion"
                                        @input="getQuestion"
                                    >
                                        <template v-slot:first>
                                            <b-form-select-option :value="null">
                                                {{$t("exam.label.all")}}
                                            </b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between align-items-center">
                                <p>{{$t("exam.label.score")}}:</p>
                                <div class="d-flex">
                                    <div class="d-flex align-items-center justify-content-between score-form">
                                        <div class="d-flex align-items-center">
                                            <p>{{$t("exam.label.from")}}</p>
                                            <input
                                                type="number"
                                                class="ml-2"
                                                max="1000"
                                                min="0"
                                                style=" border:none;width: 50px;background: #FFFFFF; height: 25px;
                                                        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);border-radius: 3px;"
                                                v-model="fillterQuestion.selected.score_from"
                                                @change="getQuestion"
                                            />
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <p>{{$t("exam.label.to")}}</p>
                                            <input
                                                type="number"
                                                class="ml-2"
                                                style=" border:none;width: 50px;background: #FFFFFF; height: 25px;
                                                        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);border-radius: 3px;"
                                                max="1000"
                                                min="0"
                                                v-model="fillterQuestion.selected.score_to"
                                                @change="getQuestion"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="create_Advanced_Diff_Top_Right">
                    <div class="d-flex">
                        <div class="d-flex form-direction">
                            <div style="width: 120px">
                                <p style="">{{$t("exam.label.price")}} <span style="color: red">* </span>:</p>
                                <p style="" class="my-2">{{$t("exam.label.discounts")}}:</p>
                                <p style="" class="my-2">{{$t("exam.label.duration")}}<span style="color: red">*</span>:</p>
                                <p style="" class="my-2">{{$t("exam.label.time_to_play")}}<span
                                    style="color: red">*</span>:
                                </p>
                                <p style="" class="my-2">{{$t("exam.label.pass_score")}}:</p>
                                <p style="" class="my-2">{{$t("exam.label.total_score")}}:</p>
                            </div>
                            <div>
                                <div class="d-flex align-items-center">
                                    <div class="">
                                        <div class="has-search-right">
                                            <input
                                                type="number"
                                                step="100"
                                                max="1000000000"
                                                min="0"
                                                class="form-control-creat-exam mr-2"
                                                v-model.number="priceEdit"
                                                id="price"
                                            />
                                        </div>
                                    </div>
                                    <span style="font-size: 12px">VND</span>
                                </div>
                                <div class="d-flex align-items-center my-2">
                                    <div class="">
                                        <div class="has-search-right">
                                            <input
                                                type="number"
                                                max="100"
                                                min="0"
                                                class="form-control-creat-exam mr-2 "
                                                v-model.number="discountEdit"
                                            />
                                        </div>
                                    </div>
                                    <span style="font-size: 12px">%</span>
                                </div>
                                <div class="d-flex align-items-center my-2">
                                    <input
                                        type="number"
                                        class="form-control-creat-exam mr-2 "
                                        v-model.number="setTime"
                                        max="1000"
                                        min="0"
                                    />
                                    <p>min</p>
                                </div>
                                <div class="form-time-to-play align-items-center mt-2">
                                    <input
                                        type="number"
                                        class="form-control-creat-exam mr-2"
                                        max="1000"
                                        min="0"
                                        v-model.number="timeToPlay"
                                    />
                                </div>
                                <div class="d-flex align-items-center my-2">
                                    <div class="">
                                        <div class="has-search-right">
                                            <input
                                                type="number"
                                                class="form-control-creat-exam mr-2"
                                                min="0"
                                                v-model.number="pass_score"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="create_Advanced_Diff_Top_Right_Bottom_Top_Score align-items-center">
                                    <input
                                        v-model="scoreQuestion"
                                        readonly
                                    />
                                </div>
                            </div>
                        </div>
                        <div style="max-width: 20vw; overflow: scroll; overflow-y:hidden; height: fit-content; box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);background-color: white">
                            <div style="font-weight: 700; text-align: center; font-size: 13px">{{ $t("exam.label.total_question") }}</div>
                            <table class="create_Advanced_Diff_Top_Right_Table">
                                <tr style="overflow-x: scroll">
                                    <th style="padding-top: 5px; color:#A0AEC0"
                                        class="create_Advanced_Diff_Top_Right_Table_Name"
                                    ></th>
                                    <th v-for="diff in listDifficulties" :key="diff.id"
                                        style="padding-top: 5px; color:#A0AEC0"
                                        class="create_Advanced_Diff_Top_Right_Table_Level text-center"
                                    >
                                        {{ diff.difficulty }}
                                    </th>
                                    <th
                                        style="padding-top: 5px; color:#A0AEC0"
                                        class="create_Advanced_Diff_Top_Right_Table_Level  text-center mx-5"
                                    >
                                        {{$t("exam.label.total")}}
                                    </th>
                                </tr>
                                <tr>
                                    <td class="create_Advanced_Diff_Top_Right_Table_Name">{{$t("exam.label.reading")}}</td>
                                    <td v-for="(countReading, index) in listCountTableTotal.reading" :key="index"
                                        class="create_Advanced_Diff_Top_Right_Table_Level text-center">
                                        {{ countReading }}
                                    </td>
                                    <td class="create_Advanced_Diff_Top_Right_Table_Level  text-center">
                                        {{
                                            this.totalReading
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="create_Advanced_Diff_Top_Right_Table_Name">
                                        {{$t("exam.label.listening")}}
                                    </td>
                                    <td v-for="(countListening, index) in listCountTableTotal.listening" :key="index"
                                        class="create_Advanced_Diff_Top_Right_Table_Level text-center">
                                        {{ countListening }}
                                    </td>
                                    <td class="create_Advanced_Diff_Top_Right_Table_Level  text-center">
                                        {{
                                            this.totalListening
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="create_Advanced_Diff_Top_Right_Table_Name">{{$t("exam.label.writing")}}</td>
                                    <td v-for="(countWriting, index) in listCountTableTotal.writing" :key="index"
                                        class="create_Advanced_Diff_Top_Right_Table_Level text-center">
                                        {{ countWriting }}
                                    </td>
                                    <td class="create_Advanced_Diff_Top_Right_Table_Level  text-center">
                                        {{
                                            this.totalWriting
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="create_Advanced_Diff_Top_Right_Table_Name">{{$t("exam.label.speaking")}}</td>
                                    <td v-for="(countSpeaking, index) in listCountTableTotal.speaking" :key="index"
                                        class="create_Advanced_Diff_Top_Right_Table_Level text-center">
                                        {{ countSpeaking }}
                                    </td>
                                    <td class="create_Advanced_Diff_Top_Right_Table_Level  text-center">
                                        {{
                                            this.totalSpeaking
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="create_Advanced_Diff_Top_Right_Table_Name">{{$t("exam.label.total")}}</td>
                                    <td v-for="(total, index) in listCountTableTotal.total" :key="index"
                                        class="create_Advanced_Diff_Top_Right_Table_Level text-center">
                                        {{
                                            total
                                        }}
                                    </td>
                                    <td class="create_Advanced_Diff_Top_Right_Table_Level total-question text-center">
                                        {{
                                            this.totalReading + this.totalListening + this.totalWriting + this.totalSpeaking
                                        }}
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <br/>
            <div class="create_Advanced_Diff_Bottom">
                <div class="create_Advanced_Diff_Bottom_Left">
                    <a-spin :spinning="isLoading">
                        <table class="create_Advanced_Diff_Bottom_Left_Table">
                            <tr>
                                <th
                                    style="padding-top: 1rem; color:#A0AEC0"
                                    class="create_Advanced_Diff_Bottom_Left_Table_Check_Box"
                                >
                                    <input type="checkbox" v-model="selectAll" @click="selectAllBox"
                                           :disabled="scoreQuestion > 1000">
                                </th>
                                <th
                                    style="padding-top: 1rem; color:#A0AEC0; text-align: center; min-width: 30px"
                                    class="create_Advanced_Diff_Bottom_Left_Table_Name"
                                >
                                    {{$t("paperslist.label.stt")}}
                                </th>
                                <th
                                    style="padding-top: 1rem; color:#A0AEC0; text-align: center"
                                    class="create_Advanced_Diff_Bottom_Left_Table_Question"
                                >
                                    {{$t("exam.label.group_question")}}
                                </th>
                                <th
                                    style="padding-top: 1rem; color:#A0AEC0; text-align: center"
                                    class="create_Advanced_Diff_Bottom_Left_Table_Question"
                                >
                                    {{$t("exam.label.question")}}
                                </th>
                                <th
                                    style="padding-top: 1rem; color:#A0AEC0; min-width: 80px;"
                                    class="create_Advanced_Diff_Bottom_Left_Table_Type"
                                >
                                    {{$t("exam.label.type")}}
                                </th>
                                <th
                                    style="padding-top: 1rem; color:#A0AEC0; min-width: 80px"
                                    class="create_Advanced_Diff_Bottom_Left_Table_Diff"
                                >
                                    {{$t("exam.label.difficulty")}}
                                </th>
                                <th
                                    style="padding-top: 1rem; color:#A0AEC0; min-width: 80px"
                                    class="create_Advanced_Diff_Bottom_Left_Table_Score"
                                >
                                    {{$t("exam.label.score")}}
                                </th>
                            </tr>
                            <!-- TODO 2 -->
                            <tr v-for="(question, index) in tableRight" :key="question.index" style="overflow: scroll">
                                <td class="input-selectbox" style="padding-top: 1rem">
                                    <input type="checkbox" v-model="selectedBox" :value="question"
                                           :disabled="scoreQuestion > 1000"/>
                                </td>
                                <td class="create_Advanced_Diff_Bottom_Left_Table_Name">{{ index + 1 }}</td>
                                <td class="create_Advanced_Diff_Bottom_Left_Table_Group"><p class="mx-2">{{ question.groupTopic}}</p></td>
                                <td class="create_Advanced_Diff_Bottom_Left_Table_Question">
                                    <div
                                        class="create_Advanced_Diff_Bottom_Left_Table_Question_Image"
                                    >
                                        <img :src="question.image_s3" alt="" v-if="question.image_s3"/>
                                        <video v-if="question.video_s3" controls>
                                            <source :src="question.video_s3" type="video/mp4">
                                        </video>
                                        <div
                                            class="create_Advanced_Diff_Bottom_Left_Table_Question_Audio mr-2"
                                            style="margin-left: 10px"
                                        >
                                            <span v-html="question.title"> </span>

                                            <audio
                                                v-if=question.audio_s3
                                                :src="question.audio_s3"
                                                controls
                                                style="width: 250px"
                                            ></audio>
                                        </div>
                                    </div>
                                </td>
                                <td class="create_Advanced_Diff_Bottom_Left_Table_Type">
                                    {{ question.type }}
                                </td>
                                <td class="create_Advanced_Diff_Bottom_Left_Table_Diff">{{ question.difficulty }}</td>
                                <td class="create_Advanced_Diff_Bottom_Left_Table_Score">{{ question.score }}</td>
                            </tr>
                        </table>
                    </a-spin>
                </div>

                <div class="move-question">
                    <ion-icon
                        class="icon-move"
                        @click="addQuestionExam"
                        style="color: #0096FF; font-size:24px"
                        name="arrow-forward-outline"
                    ></ion-icon>
                </div>

                <div class="create_Advanced_Diff_Bottom_Right" style="overflow-y: scroll;height: 55vh">
                    <table class="create_Advanced_Diff_Bottom_Left_Table">
                        <tr>
                            <th
                                style="padding-top: 1rem; color:#A0AEC0; font-size: 12px;text-align: left"
                                class="create_Advanced_Diff_Bottom_Right_Table_Name"
                            >
                                {{$t("paperslist.label.exam_stt_ext")}}
                            </th>
                            <th
                                style="padding-top: 1rem; color:#A0AEC0; text-align: center"
                                class="create_Advanced_Diff_Bottom_Left_Table_Question"
                            >
                                {{$t("exam.label.group_question")}}
                            </th>
                            <th
                                style="padding-top: 1rem; color:#A0AEC0; text-align: center;font-size: 12px"
                                class="create_Advanced_Diff_Bottom_Right_Table_Question"
                            >
                                {{$t("exam.label.question")}}
                            </th>
                            <th
                                style="padding-top: 1rem; color:#A0AEC0; text-align: center; font-size: 12px; min-width: 63px"
                                class="create_Advanced_Diff_Bottom_Right_Table_Score"
                            >
                                {{$t("exam.label.score")}}
                            </th>
                            <th
                                style="padding-top: 1rem; color:#A0AEC0; text-align: center; font-size: 12px"
                                class="create_Advanced_Diff_Bottom_Right_Table_Action"
                            >
                                {{$t("exam.label.action")}}
                            </th>
                        </tr>

                        <tr v-for="(question, index) in questionSelected" :key="index">
                            <td class="create_Advanced_Diff_Bottom_Right_Table_Name" style="padding-left: 0">
                                <table>
                                    <tr>
                                        <td>
                                            {{index + 1}}/
                                        </td>
                                        <td>
                                            <input class="input_change_score_question"
                                                   v-model="data.set_order[genKey('order', index)]"
                                                   :id="genKey('order', index)"
                                                   style="text-align: center"
                                                   @change="set_order(index)"
                                                   type="number">
                                        </td>
                                    </tr>
                                </table>
                            </td>
                            <td class="create_Advanced_Diff_Bottom_Left_Table_Group"><p class="mx-2">{{ question.groupTopic}}</p></td>
                            <td class="create_Advanced_Diff_Bottom_Right_Table_Question">
                                <div class="d-flex">
                                    <img :src="question.image_s3" alt="" v-if="question.image_s3"/>
                                    <video v-if="question.video_s3" controls>
                                        <source :src="question.video_s3" type="video/mp4">
                                    </video>
                                    <div>
                                        <div
                                            style="margin-left: 10px; text-overflow: ellipsis;white-space: nowrap; overflow: hidden; width: 300px;">
                                            <span v-html="question.title"> </span>
                                        </div>
                                        <audio
                                            v-if=question.audio_s3
                                            :src="question.audio_s3"
                                            controls
                                            style="width: 250px"
                                        ></audio>
                                    </div>
                                </div>
                            </td>

                            <td class="create_Advanced_Diff_Bottom_Right_Table_Score" v-if="!listInputScore[index]">{{ listScoreEdit[index].value }}</td>
                            <td class="create_Advanced_Diff_Bottom_Right_Table_Score" v-if="listInputScore[index]">
                                <b-input v-model.number="listScoreEdit[index].value" @change="countTotalScore" type="number" class="input_change_score_question"/>
                            </td>
                            <td class="create_Advanced_Diff_Bottom_Right_Table_Action">
                                <ion-icon
                                    @click="showQuestion(`edit`, index)"
                                    style="color: #F29D38; font-size:24px; margin: 0 5px"
                                    name="pencil-outline"
                                ></ion-icon>
                                <ion-icon
                                    @click="showQuestion(`del`, index)"
                                    style="color: red; font-size:24px"
                                    name="trash-outline"
                                ></ion-icon>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <!-- Lưu ý -->
            <div class="my-3 mx-4">
                <p>*: {{$t("exam.label.note")}}</p>
            </div>
            <!-- --> 

            <!-- start-001: Thêm trường nhập số lần được thoát full màn hình khi làm bài thi, và trường tắt thời gian đếm ngược khi làm bài thi -->
            <div style="background: #f5f5f5;" class="my-4 px-4 py-3"
            >
                <div class="number-exits-fullscreen">
                    <input
                        style="padding: 3px 8px; border-width: medium; border-style: none; border-color: currentcolor; border-image: none; width: 50px; background: rgb(255, 255, 255); height: 25px; box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 4px; border-radius: 3px;"
                        type="number"
                        v-model.number="number_exits_fullscreen"
                        min="0"
                        max="10"
                        @input="handleNumberExitsFullscreen"
                    />

                    {{ $t("exam.label.help_number_exits_fullscreen") }}
                </div>
                <div class="disable-time-to-play mt-2">
                    <input type="checkbox" v-model="disable_time" > {{ $t("exam.label.help_disable_time") }}
                </div>
            </div>   
            <!-- end-001: -->

            <!-- Start: Thêm các trường lựa chọn cho đề thi SHA của sangsang -->
            <div style="background: #f5f5f5;" class="create_Advanced_Diff_sangsang my-4 px-4 py-3"
                v-if="authUser.roles_teacher === 8"
            >
                <div class="check-sha">
                    <input type="checkbox" v-model="checkSha" > Bài thi HSA VNU
                </div>

                <div class="opt-exam-2 mt-3 mb-3 col-6" v-if="checkSha">
                    <p class="mb-2"><b>Phần 2: Bài thi định tính <span style="color: red;">*</span></b></p>
                    <div class="">
                        <b-form-select
                            v-model="selectedSHA.id_exam_2"
                            :options="convertListExamsB2B"
                            @change="filterListExamsB2B"

                        >
                            <template v-slot:first>
                                <b-form-select-option disabled :value="''">
                                    {{ '-- Chọn bài thi --' }}
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>
                </div>

                <div class="opt-exam-3 col-6" v-if="checkSha">
                    <p class=""><b>Phần 3: Tiếng anh hoặc Khoa học</b></p>
                    <div class="opt-exam-3-english mb-3">
                        <p class="mb-2">Bài thi tiếng anh <span style="color: red;">*</span>:</p>
                        <b-form-select
                            v-model="selectedSHA.id_exam_3"
                            :options="convertListExamsB2BWithOut"

                        >
                            <template v-slot:first>
                                <b-form-select-option disabled :value="''">
                                    {{ '-- Chọn bài thi --' }}
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>

                    <div class="opt-exam-3-khoa-hoc">
                        <p class="mb-2">Bài thi Khoa học (nhấn phím Ctrl và click chọn nhiều) <span style="color: red;">*</span>:</p>
                        <b-form-select
                            v-model="selectedSHA.topics.ids"
                            :options="convertListTopicsB2B"
                            multiple
                            style="min-height: 200px; padding: 10px; line-height: 2;"
                        >
                        <!-- @change="limitSelectionTopicsB2B" -->
                            <template v-slot:first>
                                <b-form-select-option disable :value="null">
                                    {{'-- Chọn chủ đề --'}}
                                </b-form-select-option>
                            </template>
                        </b-form-select>

                        <!-- <p class="mt-2 mb-2">
                            Nhập số câu hỏi:
                            <input
                                type="number"
                                class="form-control-creat-exam mr-2"
                                max="1000"
                                min="0"
                                v-model="selectedSHA.topics.num_question"
                            />
                        </p> -->

                        <!-- <p class="mb-2">
                            Nhập thời gian thi (số phút):
                            <input
                                type="number"
                                class="form-control-creat-exam mr-2"
                                max="1000"
                                min="0"
                                v-model="selectedSHA.topics.num_time"
                            />
                        </p> -->

                        <!-- <p class="mb-2">
                            Nhập số lần thi:
                            <input
                                type="number"
                                class="form-control-creat-exam mr-2"
                                max="1000"
                                min="0"
                                v-model="selectedSHA.topics.num_test"
                            />
                        </p> -->

                    </div>
                </div>

            </div>

            <!-- End: Thêm các trường lựa chọn cho đề thi SHA của sangsang -->

            <div class="create_Advanced_Diff_End my-2">
                <div class="create_Advanced_Diff_End_Button">
                    <b-button @click="onClose()" variant="danger"
                    >{{ $t("exam.label.cancel") }}
                    </b-button
                    >
                    <b-button
                        class="btn-Next"
                        @click="saveExam()"
                        style="margin-left: 1rem; width: 120px"
                        variant="primary"
                        :disabled="priceEdit.length === 0 || !setTime || !timeToPlay || questionSelected.length === 0"
                    >{{ $t("exam.label.save") }}
                    </b-button>
                </div>
            </div>
        </div>

        <div id="difficulty">
            <div>
                <div class="difficulty_header flex-wrap">
                    <div class="mb-1 input-search d-flex"
                        style="max-width: 50%; width: 500%; align-items: end"
                    >
                        <div class="col-6">


                        <b-input-group>
                            <b-input-group-prepend is-text>
                                <b-icon icon="search" class="icon-search"></b-icon>
                            </b-input-group-prepend>
                            <b-input
                                class="input-search"
                                style="border-left: none; height: 100%;"
                                v-model="fillterData.search"
                                :placeholder="$t('exam.label.search_exam')"
                                @change="searchExam"
                            ></b-input>
                        </b-input-group>
                        </div>
                        <!-- <multiselect
                            style="margin: 0 0 0 10px;"
                            v-model="selectCategory"
                            selectLabel=""
                            selectedLabel="√"
                            deselectLabel="Remove"
                            track-by="id"
                            label="category"
                            :options="listCategory"
                            :hide-selected="false"
                            :close-on-select="false"
                            :clear-on-select="false"
                            placeholder="Danh mục"
                            :multiple="true"
                            :tagable="true"
                            @select="fCategory"


                        >
                        </multiselect> -->
                        <div class="col-6">


                            <label class="pr-3">{{ $t("myExam.label.category") }}:</label>
                            <b-form-select
                                style="font-size: 14px;"
                                @change="fillterExam"
                                class="filter-dropdown"
                                :options="convertCategory"
                                v-model="fillterData.category"
                            >
                                <template v-slot:first>
                                    <b-form-select-option :value="null">
                                    {{ $t("teacher_list.option_default") }}
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </div>

                    </div>

                    <b-button @click="createExam = true; typeApi=`add`" class="btn-createExam">
                        <ion-icon name="add-outline"></ion-icon>
                        <span>{{$t('exam.label.create_exam')}}</span></b-button>
                </div>

                <div class="difficulty_middle">
                    <table class="table">
                        <thead>
                        <tr>
                            <th scope="col" class="text-center border-0" style="width: 1%; padding-left: 1px; ">
                                <input type="checkbox" v-model="selectListAll" @click="selectListAllBox">
                            </th>
                            <th scope="col" class="text-center border-0" style="width: 1%; padding-left: 1px; padding-right: 1px;">
                                <ion-icon
                                    @click="delMultiExam"
                                    style="color: red; font-size:20px"
                                    name="trash-outline"
                                ></ion-icon>
                            </th>
                            <th scope="col" class="text-center border-0">
                                {{$t("paperslist.label.stt")}}
                            </th>
                            <th scope="col" class="text-center border-0">{{$t('exam.label.image')}}</th>
                            <th scope="col" class="pl-1 border-0 text-center">{{$t('exam.label.name_exam')}}</th>
                            <th scope="col" class="pl-1 border-0 text-center">{{$t('exam.label.user-created')}}</th>
                            <th scope="col" class="pl-1 border-0 text-center">{{$t('exam.label.price')}}</th>
                            <th scope="col" class="pl-1 border-0 text-center">{{$t('exam.label.date')}}</th>
                            <th scope="col" class="pl-1 border-0 text-center">{{$t('exam.label.updated')}}</th>
                            <th scope="col" class="text-center border-0">{{$t('exam.label.action')}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(exam, index) in examRequest" :key="index">
                            <td style="padding: 0; vertical-align: inherit;">
                                <input type="checkbox" v-model="selectedListBox" :value="exam"/>
                            </td>
                            <td></td>
                            <td class="difficulty_table_id p-1 align-middle text-center">{{ (pagination.current_page - 1) * fillterData.selected.paginate + index + 1 }}</td>
                            <td class="difficulty_table_image p-1 align-middle text-center">
                                <img :src="exam.image_s3"  v-if="exam.image_s3"/>
                                <img src="../Rectangle.png" v-else/>
                            </td>
                            <td class="difficulty_table_name_exam p-1 align-middle">
                                <div>{{ exam.name }}</div>
                            </td>
                            <td class="difficulty_table_user_created p-1 align-middle text-center">{{
                                    exam.created_by
                                }}
                            </td>
                            <td class="difficulty_table_price p-1 align-middle text-center">
                                {{ exam.price.toLocaleString('it-IT', {style: 'currency', currency: 'VND'}) }}
                            </td>
                            <td class="difficulty_table_date p-1 align-middle text-center">{{ exam.created_at }}</td>
                            <td class="difficulty_table_date p-1 align-middle text-center">{{ exam.updated_at }}</td>
                            <td class="difficulty_table_action p-1 align-middle">
                                <ion-icon
                                    @click="typeApi=`edit`; idApi=exam.id; showModal(`info-exam`); "
                                    style="color: #0096FF; font-size:20px"
                                    name="eye"
                                ></ion-icon>
                                <ion-icon
                                    @click="typeApi=`edit`; idApi=exam.id; image_s3 = exam.image_s3;showEdit(exam);"
                                    style="color: #F29D38; font-size:20px"
                                    name="pencil-outline"
                                ></ion-icon>
                                <ion-icon
                                    @click="deleteExam = true; typeApi=`del`; idApi=exam.id"
                                    style="color: red; font-size:20px"
                                    name="trash-outline"
                                ></ion-icon>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="d-flex py-4 px-2">
                    <div class="col-12 col-md-8 d-flex align-items-center">
                        <div class="col-6 p-0 d-flex align-items-center">
                            <b-input
                                class="col-4 col-md-3 mr-1 mw-50"
                                type="number"
                                placeholder=""
                                @change="fillterExam"
                                v-model="fillterData.selected.paginate"
                            >
                            </b-input>
                            bản ghi/Trang
                        </div>
                        <div class="col-6 p-0 d-flex align-items-center justify-content-end justify-content-lg-center">
                            Đến trang
                            <b-input
                                @change="fillterExam"
                                class="col-4 col-md-3 ml-1 mw-50"
                                type="number"
                                placeholder=""
                                v-model="fillterData.page"
                            >
                            </b-input>

                        </div>
                    </div>

                    <div class="col-12 col-md-4 d-flex align-items-center justify-content-end">
                        <b-pagination
                            :key="`${pagination.current_page}_${pagination.total}_${pagination.per_page}`"
                            @change="change"
                            :value="pagination.current_page"
                            :total-rows="pagination.total"
                            :per-page="pagination.per_page"
                            aria-controls="my-table"
                            class="m-0"
                        ></b-pagination>
                    </div>

                </div>

            </div>
        </div>
    </div>
</template>
<script>
import {mapGetters, mapState}  from "vuex";
import Multiselect   from 'vue-multiselect';
import ModalAuto     from "./ModalAuto";
import ModalInfoExam from "@/views/Exam/ModalInfoExam";
import moment        from "moment";
import Vue           from "vue";

export default {
    components: {ModalInfoExam, ModalAuto, Multiselect},
    data() {
        return {
            data: {
                set_order: {},
                description: '',
                name :'',
                status:''
            },
            infoExam: false,
            createExam: false,
            deleteExam: false,
            advancedExam: false,
            idExam: false,
            examName: '',
            setTime: null,
            discount: null,
            priceExam: 0,
            scoreQuestion: null,
            imageFileExam: "",
            imageFileExamDefault: null,
            imageFileExamUpload: null,
            selectedMethod: 'manual',
            selectedBox: [],
            selectedListBox: [],
            questionSelected: [],
            categoryEdit: null,
            nameEdit: "",
            timeToPlay: null,
            methodEdit: "manual",
            priceEdit: 0,
            discountEdit: null,
            pass_score: null,
            tableRight: [],
            tableLeft: [],
            tableCount: {
                countEasyRead: 0,
                countMediumRead: 0,
                countHardRead: 0,
                countEasyListen: 0,
                countMediumListen: 0,
                countHardListen: 0,
                countEasyWriting: 0,
                countMediumWriting: 0,
                countHardWriting: 0
            },
            selectAll: false,
            selectListAll: false,
            typeQuestionOption: [
                {value: "Reading", text: "Reading"},
                {value: "Writing", text: "Writing"},
                {value: "Listening", text: "Listening"},
                {value: "Speaking", text: "Speaking"}
            ],
            categorySelected: null,
            categoryQuestion: [],
            difficultyQuestion: [],
            listCategory: [],
            listInputScore: [],
            listScoreEdit: [],
            fillterQuestion: {
                search: "",
                page: 1,
                selected: {
                    category: null,
                    typeQuestion: null,
                    typeOfQuestion: "General",
                    difficulty: null,
                    score: null,
                    score_from: null,
                    score_to: null,
                    discount: null,
                    categoryQuestion: null,
                    id_topic: null,
                    paginate: 300
                },
                statusQuestion: 0
            },
            fillterData: {
                search: '',
                category: null,
                cat: '',
                page: 1,
                selected: {
                    paginate: 20
                }
            },
            perPage: [
                {value: 10, text: "10"},
                {value: 20, text: "20"},
                {value: 40, text: "40"},
                {value: 60, text: "60"},
                {value: 80, text: "80"},
                {value: 100, text: "100"}
            ],
            dataInfo: [],
            typeApi: "",
            idApi: "",
            listCountTableTotal: {
                reading: [],
                listening: [],
                writing: [],
                speaking: [],
                total: []
            },
            totalReading: 0,
            totalListening: 0,
            totalWriting: 0,
            totalSpeaking: 0,
            image_s3: null,
            isLoading: false,
            selectCategory: [],
            convertCategory: [],
            checkSha: false,
            convertListExamsB2B: [],
            convertListExamsB2BWithOut: [],
            selectedSHA: {
                id_exam_2: '',
                id_exam_3: '',
                topics: {
                    ids: '',
                    num_question: '',
                    num_time: '',
                    num_test: ''
                }
            },
            convertListTopicsB2B: [],
            number_exits_fullscreen: 3,
            disable_time: false
        };
    },
    async created() {
        this.$root.$loading.start();
        await this.getCategory();
        await this.getDifficulty();
        await this.fillterExam();
        await this.getListExamsB2B();
        await this.getListTopicsB2B();
        this.$root.$loading.finish();

       // console.log(this.listTopicsB2B);

        for (let i = 0; i < this.listCategories.length; i++) {
            this.categoryQuestion.push({
                value: this.listCategories[i].category,
                text: this.listCategories[i].category
            });
        }
        for (let i = 0; i < this.listDifficulties.length; i++) {
            this.difficultyQuestion.push({
                value: this.listDifficulties[i].difficulty,
                text: this.listDifficulties[i].difficulty
            });
            this.listCountTableTotal.reading.push(0);
            this.listCountTableTotal.listening.push(0);
            this.listCountTableTotal.writing.push(0);
            this.listCountTableTotal.speaking.push(0);
            this.listCountTableTotal.total.push(0);
        }
        for (let i = 0; i < this.listCategories.length; i++) {
			this.convertCategory.push({
				value: this.listCategories[i].id,
				text: this.listCategories[i].category,
			});
		};

        for (let i = 0; i < this.listExamsB2B.length; i++) {
			this.convertListExamsB2B.push({
				value: this.listExamsB2B[i].id,
				text: this.listExamsB2B[i].name,
			});
		};

        for (let i = 0; i < this.listTopicsB2B.length; i++) {
			this.convertListTopicsB2B.push({
				value: this.listTopicsB2B[i].id,
				text: this.listTopicsB2B[i].title,
			});
		};

       // console.log(this.convertListExamsB2B);
    },
    computed: {
        ...mapGetters({
            examRequest: "exam/exam",
            listCategories: "category/category",
            listQuestions: "question/questionResponse",
            listDifficulties: "config/difficulty",
            createExamResponse: "exam/createExamResponse",
            editExamRes: "exam/editExamRes",
            delExamRes: "exam/delExamRes",
            pagination: "exam/pagination",
            listAllQuestion: "question/questionAllResponse",
            listExamsB2B: "exam/listExams",
            listTopicsB2B: "topics/listTopicsB2B"
        }),

        ...mapState('auth', { authUser: 'user' }),
        //...mapState("auth", ["user"]),

        categoryIdsAllow() {
            return this.authUser?.category_ids_apply || "";
        }
    },
    methods: {
        change: function (page) {
            this.fillterData.page = page;
            this.fillterExam();
        },
        async showEdit(exam) {
            await this.getAllQuestion(exam.id);
           // console.log(this.listAllQuestion);
            this.infoExam = true;
            this.nameEdit = exam.name;
            this.methodEdit = "manual";
            this.priceEdit = exam.price;
            this.discountEdit = exam.discount;
            this.pass_score = exam.pass_score;
            this.setTime = exam.time;
            this.timeToPlay = exam?.time_to_play;
            this.imageFileExamDefault = exam.image_path;

            let questions = exam.question_id;
            let tmpRight = [];
            for (let i = 0; i < this.listCategory.length; i++) {
                for (let j = 0; j < exam.category.length; j++) {
                    if (this.listCategory[i].category === exam.category[j]) {
                        this.categoryEdit = {
                            "category": this.listCategory[i].category,
                            "id": this.listCategory[i].id
                        };
                    }
                }
            }
            await this.getQuestion();
            this.listQuestions.data.map((ques, i) => {
                let count = 0;
                questions.forEach((idExam, j) => {
                    if (ques.id !== idExam) count++;
                });
                if (count === questions.length) {
                    tmpRight.push(this.listQuestions.data[i]);
                }
            });
            this.tableRight = tmpRight;
            this.questionSelected = this.listAllQuestion;
            /*---------------------------------------*/
            // tiemtt <tiemtt@gmail.com>
            if(this.questionSelected && questions && this.questionSelected.length > 0 && questions.length > 0) {
                let temp_draft = [];
                questions.forEach((idExam, i) => {
                    if (idExam) {
                        for (let i = 0; i < this.questionSelected.length; i++) {
                            if (this.questionSelected[i]) {
                                if (this.questionSelected[i].id == idExam) {
                                    temp_draft.push(this.questionSelected[i]);
                                    break;
                                }
                            }
                        }
                    }
                });
                this.questionSelected = temp_draft;
            }
            /*---------------------------------------*/
            this.listScoreEdit = [];
            this.listAllQuestion.forEach((item)=>{
                this.listScoreEdit.push({
                    value: item.score
                })
            });
            // JSON.parse(exam.score_ques_exam).forEach((score) => {
            //     this.listScoreEdit.push({
            //         value: score
            //     })
            // });
            /*---------------------------------------*/
            // tiemtt <tiemtt@gmail.com>
            if(this.questionSelected && this.questionSelected.length > 0) {
                for (let i = 0; i < this.questionSelected.length; i++) {
                    if (this.questionSelected[i] && this.listScoreEdit[i]) {
                        this.questionSelected[i].score = this.listScoreEdit[i].value;
                    }
                }
            }
            /*---------------------------------------*/

            this.getEditScore();
            this.countTotalDiff();

            // show thong tin HSA của bài thi nếu có

            this.checkSha = exam?.checkSha ? true : false;
            this.selectedSHA.id_exam_2 = exam?.exam_id_2;
            this.filterListExamsB2B();
            this.selectedSHA.id_exam_3 = exam?.exam_id_3_1;
            this.selectedSHA.topics.ids = exam?.str_topic_id_3_2?.split(',');
            this.selectedSHA.topics.num_question = exam?.questions_number_3_2;
            this.selectedSHA.topics.num_time = exam?.time_3_2;;
            this.selectedSHA.topics.num_test = exam?.time_to_play_3_2;;

            // end : show thong tin HSA của bài thi nếu có

            // show thông tin 2 trường number_exits_fullscreen, disable_time
            this.number_exits_fullscreen = exam?.number_exits_fullscreen;
            this.disable_time = exam?.disable_time ? true : false;
            // end: thông tin 2 trường number_exits_fullscreen, disable_time
        },
        getEditScore(){

            this.listInputScore = [];
            this.questionSelected.forEach(() => {
                this.listInputScore.push(false);
            });
            this.countTotalScore();
        },
        countTotalScore(){
            // this.scoreQuestion = 0;
            // this.listScoreEdit.forEach( score => {
            //     console.log(score);
            //     this.scoreQuestion += score.value === "" ? 0 : score.value;
            // })
            this.scoreQuestion = 0;

            this.listScoreEdit.forEach(score => {
                const value = parseFloat(score.value) || 0;
                this.scoreQuestion += value;
            });
        },
        formatTime() {
            this.examRequest.forEach((exam) => {
                exam.created_at = moment(exam.created_at).format("DD/MM/YYYY");
                exam.updated_at = moment(exam.updated_at).format("DD/MM/YYYY");
            });
        },
        showQuestion(type, index) {
            switch (type) {
                case "info":
                    break;

                case "edit":
                    this.listInputScore[index] = true;
                    this.countTotalScore()
                    break;
                case "del":
                    this.questionSelected.splice(index, 1);
                    this.listScoreEdit.splice(index, 1);
                    this.listInputScore.splice(index, 1);
                    this.scoreQuestion = 0;
                    for (let i in this.questionSelected) {
                        this.scoreQuestion += this.questionSelected[i].score;
                    }
                    this.countTotalScore();
                    this.countTotalDiff();
                    this.getQuestion();
                    break;
                default:
                    break;
            }
        },
        showModal(type) {
            if (this.imageFileExamUpload && !this.imageFileExamUpload.type.includes("jpeg")
                && !this.imageFileExamUpload.type.includes("png")
                && !this.imageFileExamUpload.type.includes("jpg") ) {
                this.$root.toast(
                    this.$t("exam.label.warning"),
                    "warning",
                    this.$t("exam.message.image_is_not_in_correct_format"));
                return;
            }
            if (this.imageFileExamUpload && this.imageFileExamUpload.size / 1048576 > 10) {
                this.$root.toast(
                    this.$t("exam.label.warning"),
                    "warning",
                    this.$t("exam.message.image_size_must_less_than_10Mb"));
                return;
            }
            this.getQuestion()
            this.infoExam = false;
            this.createExam = false;
            switch (type) {
                case "manual" :
                    this.advancedExam = true;
                    break;
                case "auto":
                    this.$bvModal.show("modal-auto");
                    break;
                case "info-exam":
                    this.$bvModal.show("modal-info-exam");
                    break;
                default:
                    this.advancedExam = true;
                    break;
            }
        },
        async fillterExam() {
            this.$root.$loading.start();
            await this.$store.dispatch("exam/getExam", this.fillterData);
            this.formatTime();
            this.$root.$loading.finish();
        },
        searchExam(){
            this.fillterData.page = 1;
            this.fillterExam();
        },
        fCategory(select){
            console.log(this.selectCategory);
            this.fillterData.category = select.id;
            this.fillterExam();
        },
        async getQuestion() {
            this.isLoading = true
            await this.$store.dispatch("question/getQuestion", this.fillterQuestion);
            this.isLoading = false

            this.selectedBox = [];

            let tmpRight = [];
            this.listQuestions.data.map((ques, i) => {
                let count = 0;
                this.questionSelected.forEach((idExam, j) => {
                    if (ques.id !== idExam.id) count++;
                });
                if (count === this.questionSelected.length) {
                    tmpRight.push(this.listQuestions.data[i]);
                }
            });
            this.tableRight = tmpRight;
        },
        async getAllQuestion(examId) {
            this.$root.$loading.start();
            await this.$store.dispatch("question/getAllQuestion",examId);
            this.$root.$loading.finish();
        },
        async getCategory() {
            await this.$store.dispatch("category/getCategory");
            this.listCategory = this.listCategories;
        },
        async getDifficulty() {
            await this.$store.dispatch("config/getDifficulty");
        },
        async getListTopicsB2B() {
            await this.$store.dispatch("topics/getListTopicsB2B");
        },

        async getListExamsB2B() {
            await this.$store.dispatch("exam/getListExams");
        },

        filterListExamsB2B(){
            this.convertListExamsB2BWithOut = [];
            this.selectedSHA.id_exam_3 = '';
            if(this.selectedSHA.id_exam_2){
                for (let i = 0; i < this.listExamsB2B.length; i++) {
                    if(this.listExamsB2B[i].id !== this.selectedSHA.id_exam_2){
                        this.convertListExamsB2BWithOut.push({
                            value: this.listExamsB2B[i].id,
                            text: this.listExamsB2B[i].name,
                        });
                    }
                };
            }
        },

        limitSelectionTopicsB2B(selected) {
            if (selected.length > 3) {
            // Giữ lại 3 lựa chọn đầu tiên
            this.selectedSHA.topics.ids = selected.slice(0, 3);
            this.$bvToast.toast('Bạn chỉ được chọn tối đa 3 chủ đề', {
                title: 'Giới hạn lựa chọn',
                variant: 'warning',
                solid: true
            });
            }
        },
        imageExam(e) {
            const file = e.target.files[0];
            this.imageFileExamUpload = file;
            this.imageFileExam = URL.createObjectURL(file);
        },
        selectAllBox() {
            this.selectedBox = [];
            if (!this.selectAll) {
                for (let i in this.tableRight) {
                    this.selectedBox.push(this.tableRight[i]);
                }
            }
        },
        selectListAllBox() {
            // tiemtt <tiemtt@gmail.com>
            this.selectedListBox = [];
            if (!this.selectListAll) {
                for (let i in this.examRequest) {
                    this.selectedListBox.push(this.examRequest[i]);
                }
            }
        },
        onClose() {
            this.infoExam = false;
            this.createExam = false;
            this.deleteExam = false;
            this.advancedExam = false;
            this.idExam = false;
            this.examName = "";
            this.status = "";
            this.setTime = "";
            this.timeToPlay = null;
            this.imageFileExam = "";
            this.imageFileExamDefault = null;
            this.imageFileExamUpload = null;
            this.discount = "";
            this.selectedMethod = 'manual';
            this.categorySelected = null;
            this.questionSelected = [];
            this.priceExam = "";
            this.selectedBox = [];
            this.categoryEdit = null;
            this.selectListAll = false;
            this.selectedListBox = [];
            this.selectAll = false;
            this.tableCount.countEasyRead = 0;
            this.tableCount.countEasyRead = 0;
            this.tableCount.countMediumRead = 0;
            this.tableCount.countHardRead = 0;
            this.tableCount.countEasyListen = 0;
            this.tableCount.countMediumListen = 0;
            this.tableCount.countHardListen = 0;
            this.tableCount.countEasyWriting = 0;
            this.tableCount.countMediumWriting = 0;
            this.tableCount.countHardWriting = 0;
            this.dataInfo = [];
            this.scoreQuestion = null;
            this.priceEdit = 0;
            this.discountEdit = null;
            this.pass_score = null;
            this.nameEdit = "";
            this.typeApi = "";
            this.idApi = "";
            this.$bvModal.hide("modal-auto");
            this.$bvModal.hide("modal-info-exam");
            this.listCountTableTotal = {
                reading: [],
                listening: [],
                writing: [],
                speaking: [],
                total: []
            };
            for (let i = 0; i < this.listDifficulties.length; i++) {
                this.listCountTableTotal.reading.push(0);
                this.listCountTableTotal.listening.push(0);
                this.listCountTableTotal.writing.push(0);
                this.listCountTableTotal.speaking.push(0);
                this.listCountTableTotal.total.push(0);
            }
            this.totalReading = 0;
            this.totalListening = 0;
            this.totalWriting = 0;
            this.totalSpeaking = 0;
            this.fillterQuestion = {
                search: "",
                page: 1,
                selected: {
                    category: null,
                    typeQuestion: null,
                    typeOfQuestion: "General",
                    difficulty: null,
                    score: null,
                    score_from: null,
                    score_to: null,
                    discount: null,
                    categoryQuestion: null,
                    id_topic: null,
                    paginate: 300
                },
                statusQuestion: 0
            };
            this.image_s3 = null;
            this.listScoreEdit = [];
            this.listInputScore = [];
            this.checkSha = false;
            this.selectedSHA.id_exam_2 = '';
            this.selectedSHA.id_exam_3 = '';
            this.selectedSHA.topics.ids = '';

            this.disable_time = false;
            this.number_exits_fullscreen = 3;
        },
        formatfilename() {
            return "Upload Image";
        },
        removeImage() {
            this.imageFileExam = "";
        },
        addQuestionExam() {
            this.selectAll = false;
            this.selectedBox.forEach(index => {
                this.questionSelected.push(index);
                this.listScoreEdit.push({value: index.score})
            });

            let tmp = [];
            this.tableRight.map((ques, i) => {
                let count = 0;
                this.selectedBox.forEach((idExam, j) => {
                    if (ques.id !== idExam.id) count++;
                });
                if (count === this.selectedBox.length) {
                    tmp.push(this.tableRight[i]);
                }
            });
            this.tableRight = tmp;

            this.countTotalScore();
            this.selectedBox = [];
            this.countTotalDiff();
        },
        delMultiExam(){
            // tiemtt <tiemtt@gmail.com>
            let str_ids = '';
            this.selectedListBox.forEach(exam => {
                if(exam){
                    str_ids += str_ids != '' ? '-exam-del-' + exam.id : exam.id;
                }
            });
            this.deleteExam = true;
            this.typeApi=`del`;
            this.idApi=str_ids
        },
        countTotalDiff() {
            for (let i = 0; i < this.listDifficulties.length; i++) {
                this.listCountTableTotal.reading[i] = 0;
                this.listCountTableTotal.listening[i] = 0;
                this.listCountTableTotal.writing[i] = 0;
                this.listCountTableTotal.speaking[i] = 0;
                this.listCountTableTotal.total[i] = 0;
            }
            this.totalReading = 0;
            this.totalListening = 0;
            this.totalWriting = 0;
            this.totalSpeaking = 0;

            this.questionSelected.forEach((question) => {
                if (question.type === "Reading") {
                    this.listDifficulties.forEach((difficulty, index) => {
                        if (question.difficulty === difficulty.difficulty) {
                            this.listCountTableTotal.reading[index] += 1;
                        }
                    });
                } else if (question.type === "Listening") {
                    this.listDifficulties.forEach((difficulty, index) => {
                        if (question.difficulty === difficulty.difficulty) {
                            this.listCountTableTotal.listening[index] += 1;
                        }
                    });
                } else if (question.type === "Writing") {
                    this.listDifficulties.forEach((difficulty, index) => {
                        if (question.difficulty === difficulty.difficulty) {
                            this.listCountTableTotal.writing[index] += 1;
                        }
                    });
                } else if (question.type === "Speaking") {
                    this.listDifficulties.forEach((difficulty, index) => {
                        if (question.difficulty === difficulty.difficulty) {
                            this.listCountTableTotal.speaking[index] += 1;
                        }
                    });
                }
            });

            this.listDifficulties.forEach((difficulty, index) => {
                this.listCountTableTotal.total[index] = this.listCountTableTotal.reading[index] + this.listCountTableTotal.listening[index] + this.listCountTableTotal.writing[index] + this.listCountTableTotal.speaking[index];
                this.totalReading += this.listCountTableTotal.reading[index];
                this.totalListening += this.listCountTableTotal.listening[index];
                this.totalWriting += this.listCountTableTotal.writing[index];
                this.totalSpeaking += this.listCountTableTotal.speaking[index];
            });
        },
        async saveExam() {
            if(this.typeApi === 'del'){
                this.$root.$loading.start();
                await this.$store.dispatch("exam/del", this.idApi);
                if (this.$store.state.exam.delExamRes.status === 200) {
                    this.fillterExam();
                    this.$root.toast(
                        this.$t("commons.label.create_success_title"),
                        "success",
                        this.$t("exam.message.delete_exam_success")
                    );
                } else {
                    this.$root.toast(
                        this.$t("commons.message.send_fail"),
                        "danger",
                        this.$store.state.exam.delExamRes.message === "E_UC2.1_30"
                            ? this.$t("exam.message.not_role")
                            :  this.$t("problem_create.message.data_invalid")
                    );
                }
                this.onClose()
                this.$root.$loading.finish();
                return;
            }

            if (this.imageFileExamUpload && !this.imageFileExamUpload.type.includes("jpeg")
                && !this.imageFileExamUpload.type.includes("png")
                && !this.imageFileExamUpload.type.includes("jpg") ) {
                this.$root.toast(
                    this.$t("exam.label.warning"),
                    "warning",
                    this.$t("exam.message.image_is_not_in_correct_format"));
                return;
            }
            if (this.imageFileExamUpload && this.imageFileExamUpload.size / 1048576 > 10) {
                this.$root.toast(
                    this.$t("exam.label.warning"),
                    "warning",
                    this.$t("exam.message.image_size_must_less_than_10Mb"));
                return;
            }

            let categories = [];
            let question_id = [];
            let score_ques_exam = [];
            if (this.categorySelected) {
                categories.push(this.categorySelected.id);
            } else {
                categories.push(this.categoryEdit.id);
            }

            for (let i in this.questionSelected) {
                question_id.push(this.questionSelected[i].id);
            }

            this.listScoreEdit.forEach((score) => {
                score_ques_exam.push(score.value === "" ? 0 : score.value);
            })
            let params = new FormData();

            params.append("name", this.typeApi === "add" ? this.examName : this.nameEdit);
            params.append("status", "Active");
            params.append("time", this.setTime);
            params.append("image_path", this.imageFileExamUpload ? this.imageFileExamUpload : this.imageFileExamDefault);
            params.append("discount", this.discountEdit ? this.discountEdit : 0);
            params.append("pass_score", this.pass_score ? this.pass_score : 0);
            params.append("method", this.methodEdit);
            params.append("question_id", JSON.stringify(question_id));
            params.append("score_ques_exam", JSON.stringify(score_ques_exam));
            params.append("category", JSON.stringify(categories));
            params.append("price", this.priceEdit);
            params.append("time_to_play", this.timeToPlay);

            // check nếu chọn SHA của sangsang

            if(this.checkSha === true){
                params.append("checkSha", 1);
                params.append("exam_id_2", this.selectedSHA.id_exam_2);
                params.append("exam_id_3_1", this.selectedSHA.id_exam_3);
                params.append("str_topic_id_3_2", this.selectedSHA.topics.ids);
                params.append("questions_number_3_2", this.selectedSHA.topics.num_question);
                params.append("time_3_2", this.selectedSHA.topics.num_time);
                params.append("time_to_play_3_2", this.selectedSHA.topics.num_test);
            }else{
                params.append("checkSha", 0);
            }

            // end: check nếu chọn SHA của sangsang
             params.append("number_exits_fullscreen", this.number_exits_fullscreen);
             params.append("disable_time", this.disable_time ? 1 : 0);
               

            let idApi = this.idApi;

            if (this.priceEdit > 1000000000 || this.priceEdit % 1000 !== 0 || this.priceEdit < 0) {
                this.$root.toast(
                    this.$t("exam.message.save_exam_fall"),
                    "danger",
                    this.$t("exam.label.price") + " " + this.$t("exam.message.is_a_positive_integer_less_than_or_equal_to")
                    + " " + this.$t("exam.message.1_billion") + " " + this.$t("exam.message.and_divisible_by_1000")
                );
                return;
            }
            if (this.discountEdit > 100 || this.discountEdit < 0) {
                this.$root.toast(
                    this.$t("exam.message.save_exam_fall"),
                    "danger",
                    this.$t("buyExam.label.discounts") + " " + this.$t("exam.message.is_a_positive_integer_less_than_or_equal_to") + " 100"
                );
                return;
            }
            if (this.pass_score > this.scoreQuestion || this.pass_score < 0) {
                this.$root.toast(
                    this.$t("exam.message.save_exam_fall"),
                    "danger",
                    this.$t("exam.message.pass_score_fall")
                );
                return;
            }
            if (this.setTime > 1000 || this.setTime < 0) {
                this.$root.toast(
                    this.$t("exam.message.save_exam_fall"),
                    "danger",
                    this.$t("exam.label.duration") + " " + this.$t("exam.message.is_a_positive_integer_less_than_or_equal_to") + " 1000"
                );
                return;
            }
            if (this.timeToPlay > 1000 || this.timeToPlay < 0) {
                this.$root.toast(
                    this.$t("exam.message.save_exam_fall"),
                    "danger",
                    this.$t("exam.label.time_to_play") + " " + this.$t("exam.message.is_a_positive_integer_less_than_or_equal_to") + " 1000"
                );
                return;
            }

            this.$root.$loading.start();

            switch (this.typeApi) {
                case "add":
                    await this.$store.dispatch("exam/create", params);
                    if (this.$store.state.exam.createExamResponse.status == 200) {
                        this.fillterExam();
                        this.$root.toast(
                            this.$t("commons.label.create_success_title"),
                            "success",
                            this.$t("exam.message.create_exam_success")
                        );
                    } else {
                        this.$root.toast(
                            this.$t("problem_create.message.create_false"),
                            "danger",
                            this.$store.state.exam.createExamResponse.message === "E_UC2.1_30"
                                ? this.$t("exam.message.not_role")
                                :  this.$t("problem_create.message.data_invalid")
                        );
                    }
                    break;
                case "edit":
                    let param = {id: idApi, body: params};
                    await this.$store.dispatch("exam/edit", param);
                    if (this.$store.state.exam.editExamRes.status === 200) {
                        this.fillterExam();
                        this.$root.toast(
                            this.$t("commons.label.create_success_title"),
                            "success",
                            this.$t("exam.message.edit_exam_success")
                        );
                    } else {
                        this.$root.toast(
                            this.$t("problem_create.message.edit_false"),
                            "danger",
                            this.$store.state.exam.editExamRes.message === "E_UC2.1_30"
                                ? this.$t("exam.message.not_role")
                                :  this.$t("problem_create.message.data_invalid")
                        );
                    }
                    break;
            }
            this.$root.$loading.finish();
            this.onClose();
        },
        genKey(val1, val2){
            return `${val1}_${val2}`;
        },
        set_order(index){
            // tiemtt <tiemtt@gmail.com>
            let tmp = [];
            let j = this.data.set_order['order_' + index];
            this.data.set_order['order_' + index] = '';
            if(j <= 0){
                this.$root.toast(
                    this.$t("exam.label.warning"),
                    "warning",
                    this.$t("exam.message.order_exam_message"));
                return;
            }else{
                j = j - 1;
            }
            if(j < index) {
                for (let i = 0; i < this.questionSelected.length; i++) {
                    if (i < j) {
                        if (this.questionSelected[i]) {
                            tmp.push(this.questionSelected[i]);
                        }
                    } else if (i == j) {
                        tmp.push(this.questionSelected[index]);
                        break;
                    }
                }
                for (let i = j; i < this.questionSelected.length; i++) {
                    if (i != index) {
                        if (this.questionSelected[i]) {
                            tmp.push(this.questionSelected[i]);
                        }
                    }
                }
            }else if(j > index && j < this.questionSelected.length){
                for (let i = 0; i <= this.questionSelected.length; i++) {
                    if (i <= j && i != index) {
                        if (this.questionSelected[i]) {
                            tmp.push(this.questionSelected[i]);
                        }
                    } else if (i == j + 1) {
                        tmp.push(this.questionSelected[index]);
                        break;
                    }
                }
                for (let i = j + 1; i <= this.questionSelected.length; i++) {
                    if (this.questionSelected[i]) {
                        tmp.push(this.questionSelected[i]);
                    }
                }
            }
            if(tmp && tmp.length > 0) {
                this.questionSelected = [];
                this.listScoreEdit = [];
                this.questionSelected = tmp;
                this.questionSelected.forEach(item => {
                    this.listScoreEdit.push({value: item.score})
                });
            }
            return;
            /*--------------------------------*/
        },
        checkCategoryPermission(item, type) {
            if (!item) return;

             

            // Không phải tài khoản giáo viên B2B thì không cần check quyền category
            const businessId = Number(this.authUser?.business_id || 0);
            if (businessId <= 0) {
                return;
            }
            // ENd check tài khoản giáo viên

            const allowedIds = (this.categoryIdsAllow || "")
                .split(",")
                .map(id => String(id).trim())
                .filter(Boolean);

            if (!allowedIds.includes(String(item.id))) {
                this.$root.toast(
                this.$t(`msg["title_notification"]`),
                "danger",
                this.$t(`msg["content_noti_exam"]`),
                );

                if (type === "edit") {
                this.categoryEdit = null;
                } else {
                this.categorySelected = null;
                }
            }
        },
        handleNumberExitsFullscreen() {
            if (this.number_exits_fullscreen < 0) {
                this.number_exits_fullscreen = 0;
            }

            if (this.number_exits_fullscreen > 10) {
                this.number_exits_fullscreen = 10;
            }
        }
    }

};
</script>
<style>
@import "../../assets/scss/List.scss";
</style>
